<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
          class="py-6 px-md-6"
          v-for="(item, i) in filteredCategories"
          :key="i"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.name}`"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catOthers",

  components: { CatCard },

  data: () => ({
    serviceName: "Qrland",
    componentName: "catOthers",
    helpData: [],
  }),

  computed: {
    categories() {
      return [
        {
          name: this.$t("categories.tombstone"),
          value: "tombstone",
          route: "qr.link",
          colors: ["#e43a15", "#e65245", "#e43a15"],
          icon: "mdi-cross",
          comingSoon: true,
        },
         {
      name: this.$t("categories.gift"),
      value: "gift",
      route: "qr.gift",
      colors: ["#8A151B", "#E3242B", "#99592A"],
      fadedcolors: ["#8A151B33", "#E3242B33", "#99592A33"],
      icon: "mdi-hand-heart-outline",
    },
      ];
    },
    filteredCategories() {
      const currentLocale = this.$i18n.locale;
      if (currentLocale === "fa") {
        return this.categories;
      }
      // return [];
      return this.categories.map((x) => ({ ...x, comingSoon: true }));
    },
  },

  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
